/**
 * Kid Palette — JS color constants for inline styles, Confetti, etc.
 * Single source of truth alongside CSS custom properties in design-tokens.css
 */

export const kidPalette = {
  // Primary — "Finger Paint" palette
  dandelion:  '#FFD43B',
  tangerine:  '#FF922B',
  berry:      '#F06595',
  ocean:      '#22B8CF',
  meadow:     '#51CF66',

  // Accent / Celebration
  violet:     '#9775FA',
  coral:      '#FF6B6B',
  bubblegum:  '#F783AC',
  sky:        '#74C0FC',

  // Background & Surface
  bg:         '#FFF9F0',
  bgAlt:      '#FFF3E0',
  surface:    '#FFFFFF',
  text:       '#2B1A4E',
  textSoft:   '#7C6A9A',
  border:     '#E8DFF5',
} as const;

/** Subset used for confetti / celebration particles */
export const kidConfettiColors = [
  kidPalette.ocean,
  kidPalette.violet,
  kidPalette.berry,
  kidPalette.dandelion,
  kidPalette.tangerine,
  kidPalette.sky,
];
